import { ref } from 'vue'

// We define this outside the function so the state is shared globally (singleton)
const isLoading = ref(false)

export function useLoader() {
  const show = () => {
    isLoading.value = true
  }

  const hide = () => {
    isLoading.value = false
  }

  return {
    isLoading,
    show,
    hide,
  }
}
